import { css, Theme } from "@emotion/react"

export const buttonStyle = (theme: Theme) => css`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	padding: 0;
	margin: 0;
	background: transparent;
	border: none;
	color: ${theme.palette.colors.brandDeepNavy};
	font-size: 1rem;
	font-weight: 700;
	text-transform: uppercase;
	cursor: pointer;

	span {
		margin-right: 1rem;
	}
`

export const mobileContactUsStyle = (theme: Theme) => css`
	ul {
		display: flex;
		flex-direction: column;
		gap: 0.5rem;
		margin: 1rem 0;
		a {
			display: flex;
			flex-direction: row;
			align-items: flex-start;
			gap: 1rem;
			font-size: 0.875rem;
			text-decoration: none;

			&:hover {
				color: ${theme.palette.colors.brandDeepNavy};
			}
		}
	}
`
